(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxWidgetNavigationItem', {
		bindings: {
			item: '<',
		},
		require: {
			navigationController: '^^mxWidgetNavigation',
		},
		controller: MxWidgetsPanelController,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-left-side-panel/mx-widgets-panel/widgets/mx-widget-navigation-item.html',
	});

	MxWidgetsPanelController.$inject = [];
	function MxWidgetsPanelController() {
		var vm = this;

		vm.$onInit = function () {};
		return vm;
	}
})();
